import React from 'react';

import classnames from 'classnames';

import styles from './styles.module.scss';

const AlertIndicator = ({ children = 0, className }) =>
  children > 0 ? (
    <div className={classnames(styles.alertIndicator, className)}>
      {children}
    </div>
  ) : null;

export default AlertIndicator;
